import { Home } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const HomeIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
}) => <Home width={size} height={size} color={color} />;

HomeIcon.displayName = 'HomeIcon';
export default HomeIcon;
